export default {
	unexpectedError: "Unexpected error: {message}",
	deleteCommitmentError: "Failed to delete action item: {message}",
	deleteCommitmentSuccess: "Action item deleted",
	saveCommitmentError: "Failed to save action item: {message}",
	saveCommitmentSuccess: "Action item saved",
	pageCommitmentsError: "Failed to fetch action items: {message}",
	filterCommitmentsError: "Failed to filter action items: {message}",
};
